<template src="../templates/cloneForm.html">

</template>

<script>
    import LayoutModel from "../models/layoutModel";
    import CloneModel from "../models/cloneModel";

    export default {
        name: "CloneFormComponent",
        data() {
            return {
                cloneModel: new CloneModel(),
                layoutModel: new LayoutModel(),
                forms: [],

            }
        },
        methods: {
            loadForms: function () {
                let url = this.$localApiURL + "layout/dynamicForms/11-12";
                let localThis = this;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(function (response) {
                    //
                    localThis.forms = response.data;

                }).catch(function (error) {
                    // handle error
                    console.log(error);
                });
            },
            cloneForm: function () {

                let localThis = this;
                let url = this.$localApiURL + "layout/clone/" + this.cloneModel.layoutId;
                this.$http.post(url, {
                    token: localStorage.getItem("jwt")
                }).then(function (response) {
                    //
                    if (response.data === "true") {
                        localThis.loadForms();
                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                });
            }

        }, created: function () {
            this.loadForms();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/CloneFormComponent.vue